export default __webpack_public_path__ + "static/media/SD-20.f8c6a0ca.jpg";